<template>
    <div class="dateIcon__container">
        <h4 class="dateIcon__dayString" v-text="day"></h4>
        <p class="dateIcon__dayNumber no-margin" v-text="dayOfMonth"></p>
        <h4 class="dateIcon__month" v-text="month"></h4>
    </div>
</template>

<script>
import { formatDate } from '@/helpers/DateHelpers';
import * as Dates from '@/constants/Dates';

export default {
    name: 'DeliveryDateBox',
    props: {
        date: {
            required: true,
            type: Date,
        },
    },
    computed: {
        day() {
            return formatDate(this.date, Dates.SHORT_DAY);
        },
        dayOfMonth() {
            return formatDate(this.date, Dates.SINGLE_NUMBER_DAY);
        },
        month() {
            return formatDate(this.date, Dates.SHORT_MONTH);
        },
    },
};
</script>
